import React , { useEffect } from 'react'; 
import FormContainer from './FormContainer';
import storage from '../factory/StorageFactory.js';
import config from '../appconfig/config.json';

const MyInfoError = (props) => {

    useEffect(() => {
        storage.clearAll();
     }, []);

    const handleOnClick = () =>{
        window.location.href = config.link.GetInTouch;
    }

    const displayErrMsg = () => {
        let errMsg = 'Your Myinfo login is unsuccessful.'
        if(props.location.state !== undefined) {
            let errType = props.location.state.errType;
            if(errType === config.ErrType.InvalidCompType){
                errMsg = 'Your request is unsuccessful due to business type.';
            }
            else if(errType === config.ErrType.InvalidPosition) {
                errMsg = 'Your Myinfo login is unsuccessful.';
            }
            else {
                errMsg = 'Your Myinfo login is unsuccessful.';
            }
        }
        else {
            errMsg = 'Your Myinfo login is unsuccessful.';
        }
        return errMsg;
    }

    return(
        <div>
        <FormContainer>
        <div className="row around-xs elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <legend id={'ftitle'} style={{textAlign:'center',paddingTop:'20px'}}>{'Oops!'}</legend>
            </div>
        </div>
        <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
        <div className="row around-xs elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px'}}>{displayErrMsg()}</legend>
            </div>
        </div>
     

        <div className="row around-xs inputPair elementVisible">
        <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="text-center" style={{padding: "20px"}}>
                <div>
                <button className="k-button btn btn-success" onClick={handleOnClick}>Get in touch</button>
                </div>
            </div>
        </div>                          
        </div> 
        </FormContainer>
       
        </div>
    )
}

export default MyInfoError;